module.exports = __webpack_public_path__ + "img/force-scan.33f8ce70.svg";